import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import PlatformProof from '../components/PlatformProof';
import Features from '../components/Features';
import Screenshots from '../components/Screenshots';
import Download from '../components/Download';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black text-[#fffefa]">
      <Header />
      <Hero />
      <Features />
      <Screenshots />
      <PlatformProof />
      <Download />
      <Footer />
    </div>
  );
};

export default HomePage;
